/* eslint-disable */

document.addEventListener("alpine:init", () => {
    Alpine.data("cookiePolicy", () => ({
        init() {
            document.addEventListener("click", function(event) {
                if (event.target.closest(".ot-close-icon")) {
                  window.OneTrust?.Close();
                }
            });
        },
        toggleOneTrust() {
            window.OneTrust?.ToggleInfoDisplay();
        },
    }));
});